import React from "react";
import PanasonicImage from "../../assets/images/client-logo-panasonic.png";
import MakeMyTripImage from "../../assets/images/client-logo-make-my-trip.png";
import SodexoImage from "../../assets/images/client-logo-sodexo.png";
import TataImage from "../../assets/images/client-logo-tata.png";
import EyImage from "../../assets/images/client-logo-ey.png";
import PeaceChannelImage from "../../assets/images/client-logo-peace-channel.png";
import CanonImage from "../../assets/images/client-logo-canon.png";
import BMWImage from "../../assets/images/client-logo-bmw.png";
import MahindraRiseImage from "../../assets/images/client-logo-mahindra-rise.png";
import AirtelImage from "../../assets/images/client-logo-airtel.png";
import ITCImage from "../../assets/images/client-logo-itc.png";
import IIMAhamadabadImage from "../../assets/images/client-logo-iim-ahamadabad.png";
import LemonTreeHotelImage from "../../assets/images/client-logo-lemon-tree-hotel.png";
import WurthImage from "../../assets/images/client-logo-wurth.png";
import DellImage from "../../assets/images/client-logo-dell.png";
import SimenseImage from "../../assets/images/client-logo-simense.png";
import CarrefourImage from "../../assets/images/client-logo-carrefour.png";
import BimtechImage from "../../assets/images/client-logo-bimtech.png";
import RamcoImage from "../../assets/images/client-logo-ramco.png";

const clientLogos = [
  PeaceChannelImage,
  CanonImage,
  EyImage,
  MakeMyTripImage,
  BMWImage,
  PanasonicImage,
  MahindraRiseImage,
  AirtelImage,
  ITCImage,
  IIMAhamadabadImage,
  LemonTreeHotelImage,
  WurthImage,
  DellImage,
  SimenseImage,
  TataImage,
  SodexoImage,
  CarrefourImage,
  BimtechImage,
  RamcoImage,
  TataImage
];

const Services = () => {
  return (
    <section className="tw-py-20 lg:tw-py-24 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100" id="satisfied-clients">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">
        
        {/* Section Title */}
        <h2 className="tw-text-center tw-text-2xl sm:tw-text-3xl tw-font-extrabold tw-text-slate-900 tw-leading-tight tw-mb-12">
          Some of our satisfied clients
        </h2>

        {/* 5-Column Grid */}
        <div className="tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 md:tw-grid-cols-4 lg:tw-grid-cols-5 tw-gap-6">
          {clientLogos.map((logo, idx) => (
            <div
              key={idx}
              className="tw-bg-white tw-border tw-border-solid tw-border-slate-100 tw-rounded-2xl tw-p-6 tw-flex tw-items-center tw-justify-center tw-h-24 tw-shadow-sm hover:tw-shadow-md hover:tw-scale-105 tw-transition-all tw-duration-300"
            >
              <img
                src={logo}
                alt="Client Logo"
                className="tw-max-h-12 tw-max-w-full tw-object-contain tw-opacity-80 hover:tw-opacity-100 tw-transition-opacity tw-duration-300"
                loading="lazy"
              />
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Services;
